<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  commissionLabel: { type: String, required: true },
  currentLabel: { type: String, default: '' },
  expectedLabel: { type: String, default: '' },
  installmentLabel: { type: String, required: true },
  showMismatch: { type: Boolean, default: false },
});

const { t } = useI18n();
</script>

<template>
  <div class="flex flex-wrap items-center justify-between gap-3">
    <h2 class="font-redHatDisplay text-xl font-bold text-lais-text">
      {{ t('SALES.PENDING_CHARGE.PAYER_EDITOR.TITLE') }}
    </h2>
    <span
      v-tooltip.top="
        t('SALES.PENDING_CHARGE.PAYER_EDITOR.RATEIO_TOOLTIP', {
          installment: installmentLabel,
          commission: commissionLabel,
        })
      "
      class="rounded-full bg-orange-100 px-3 py-1 text-sm font-semibold text-orange-800"
    >
      {{ installmentLabel }}
    </span>
  </div>
  <p
    v-if="showMismatch"
    class="mt-5 rounded-lais bg-red-50 p-3 text-sm text-red-700"
  >
    {{
      t('SALES.PENDING_CHARGE.PAYER_EDITOR.TOTAL_MISMATCH', {
        current: currentLabel,
        expected: expectedLabel,
      })
    }}
  </p>
</template>
